import {useEffect, useState} from "react";
import appConstants from '../../../../constants';
import { selectFilterValue, unselectFilterValue } from '../../helpers';
import capitalizeWords from "../../../../utils/capitalizeWords";

const defaults = Object.freeze({
  initialSelectedPartnerRole: null,
  initialSelectedPartnerRoleCode: null,
  incomingLinkRole: null
});

export default function usePartnerRoleFilter(
  partnerRoleList,
  initialSelectedPartnerRole = defaults.initialSelectedPartnerRole,
  incomingLinkRole = defaults.incomingLinkRole
) {
  const [isPartnerRoleFilterDropdownOpened, setIsPartnerRoleFilterDropdownOpened] = useState(false);
  const [partnerRoleFilterValues, setPartnerRoleFilterValues] = useState([]);

  const [selectedPartnerRole, setSelectedPartnerRole] = useState(initialSelectedPartnerRole);
  const [selectedPartnerRoleCode, setSelectedPartnerRoleCode] = useState(!!initialSelectedPartnerRole ? initialSelectedPartnerRole[appConstants.KEY_CODE] : defaults.initialSelectedPartnerRoleCode);


  function selectPartnerRoleFilterValue(partnerRoleFilterValue) {
    const updatePartnerRoleFilterOperationResults =
      selectFilterValue(partnerRoleFilterValue, partnerRoleFilterValues);
    if (updatePartnerRoleFilterOperationResults.areFilterValuesUpdated) {
      setPartnerRoleFilterValues(previousValue => [...updatePartnerRoleFilterOperationResults.updatedFilterValues]);
      let selectedPartnerRoleFilterValue = { ...partnerRoleFilterValue };
      selectedPartnerRoleFilterValue[appConstants.KEY_IS_SELECTED] = true;
      setSelectedPartnerRole( previousValue => selectedPartnerRoleFilterValue);
      setSelectedPartnerRoleCode(previousValue => partnerRoleFilterValue[appConstants.KEY_CODE]);
      setIsPartnerRoleFilterDropdownOpened(previousValue => false);
    }
  }
  function unselectPartnerRoleFilterValue(partnerRoleFilterValue) {
    const updatePartnerRoleFilterOperationResults =
      unselectFilterValue(partnerRoleFilterValue, partnerRoleFilterValues);
    if (updatePartnerRoleFilterOperationResults.areFilterValuesUpdated) {
      setPartnerRoleFilterValues(previousValue => [...updatePartnerRoleFilterOperationResults.updatedFilterValues]);
      setSelectedPartnerRole( previousValue => null);
      setSelectedPartnerRoleCode(previousValue => null);
      setIsPartnerRoleFilterDropdownOpened(previousValue => false);
    }
  }

  function resetPartnerRoleFilterValues() {
    setPartnerRoleFilterValues( previousValue => [...partnerRoleList]);
    setSelectedPartnerRole( previousValue => null);
    setSelectedPartnerRoleCode( previousValue => null);
  }
  function togglePartnerRoleFilterDropdown() {
    setIsPartnerRoleFilterDropdownOpened(previousValue => !isPartnerRoleFilterDropdownOpened);
  }

  useEffect(
    () => {
      if(!!partnerRoleList && !!partnerRoleList.length) {
        if (!!incomingLinkRole) {
          const toBeSelectedRoleCode = capitalizeWords(incomingLinkRole);
          let toBeSelectedRole = partnerRoleList.filter((partnerRole) => partnerRole[appConstants.KEY_CODE] === toBeSelectedRoleCode);
          if (!!toBeSelectedRole.length) {
            toBeSelectedRole = {...toBeSelectedRole[0]};
            toBeSelectedRole[appConstants.KEY_IS_SELECTED] = true;
            setSelectedPartnerRole(toBeSelectedRole);
            setPartnerRoleFilterValues(previousValue => {
              const updatedPartnerRoleList = partnerRoleList.map((partnerRole) => partnerRole[appConstants.KEY_CODE] === toBeSelectedRole[appConstants.KEY_CODE] ? toBeSelectedRole : partnerRole);
              return [...updatedPartnerRoleList];
            });
            setSelectedPartnerRoleCode(toBeSelectedRole[appConstants.KEY_CODE]);
          }
        }
        else {
          if (!!initialSelectedPartnerRole) {
            setPartnerRoleFilterValues(previousValue => {
              const updatedPartnerRoleList = partnerRoleList.map((partnerRole) => partnerRole[appConstants.KEY_CODE] === initialSelectedPartnerRole[appConstants.KEY_CODE] ? initialSelectedPartnerRole : partnerRole);
              return [...updatedPartnerRoleList];
            });
          }
          else {
            setPartnerRoleFilterValues(previousValue => [...partnerRoleList]);
          }
        }
      }
    },
    [partnerRoleList, initialSelectedPartnerRole, incomingLinkRole]
  );

  return {
    partnerRoleFilterValues,
    isPartnerRoleFilterDropdownOpened,
    selectedPartnerRole,
    selectedPartnerRoleCode,
    selectPartnerRoleFilterValue,
    unselectPartnerRoleFilterValue,
    resetPartnerRoleFilterValues,
    togglePartnerRoleFilterDropdown
  }

}
